export function AssignedUserBubble({ user }: { user: string; }) {
    return (
        <div className="px-2 py-1 rounded-md bg-stone-100 dark:text-stone-900">{user}</div>
    )
}